module.exports = __webpack_public_path__ + "static/media/README.ce64dc03.md";